import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-3">
            Kategorie Produktów
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Przeglądaj <span className="text-primary-500">Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Wszystkie kategorie dostępne w arkuszu Kakobuy. Kliknij, aby przejść do pełnej listy produktów na naszej głównej stronie.
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 hover:bg-accent-50 rounded-xl border border-background-200/60 hover:border-accent-200 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              {/* Category Image */}
              <div className="w-full aspect-square overflow-hidden bg-secondary-100">
                <img
                  src={cat.image}
                  alt={`Kategoria ${cat.name} - Kakobuy Spreadsheet`}
                  title={`${cat.name} - Kakobuy Spreadsheet produkty`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              {/* Category Info */}
              <div className="flex items-center gap-2 p-3 md:p-3.5">
                <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors text-accent-600 group-hover:text-accent-700 flex-shrink-0">
                  <i className={`${cat.icon} text-sm md:text-base`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-950 whitespace-nowrap transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}